export const registerServiceWorker = async (config, onUpdate) => {
  if (
    !config.enabled ||
    !config.serviceWorkerUrl ||
    !("serviceWorker" in navigator) ||
    !window.isSecureContext
  ) {
    return null;
  }

  const registration = await navigator.serviceWorker.register(config.serviceWorkerUrl, {
    scope: config.scope,
    updateViaCache: "none",
  });

  const signalWaiting = (worker) => {
    if (!worker) return;
    onUpdate?.({
      apply: () => worker.postMessage({ type: "SKIP_WAITING" }),
    });
  };

  if (registration.waiting && navigator.serviceWorker.controller) {
    signalWaiting(registration.waiting);
  }

  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    worker?.addEventListener("statechange", () => {
      if (worker.state === "installed" && navigator.serviceWorker.controller) {
        signalWaiting(worker);
      }
    });
  });

  window.setTimeout(() => registration.update().catch(() => {}), 3000);
  return registration;
};
